import React from 'react';
import { Modal } from 'syngenta-digital-cropwise-react-ui-kit';

import DiscardIcon from 'assets/DiscardIcon';
import './index.css';

interface ConfirmModalConfig {
  icon?: React.ReactNode;
  title: React.ReactNode;
  titleStyles?: React.CSSProperties;
  titleIconGap?: number;
  content: React.ReactNode;
  contentStyles?: React.CSSProperties;
  contentTextStyles?: React.CSSProperties;
  contentGutterWidth?: number;
  okText: string;
  okButtonProps?: Record<string, any>;
  cancelText: string;
  cancelButtonProps?: Record<string, any>;
  onOk: () => void;
  afterClose?: () => void;
  width?: number | string;
}

const showConfirmModal = ({
  icon = <DiscardIcon />,
  title,
  titleStyles,
  titleIconGap = 12,
  content,
  contentStyles = { paddingRight: 36, fontSize: 16, lineHeight: '24px' },
  contentTextStyles,
  contentGutterWidth = 36,
  okButtonProps = {
    style: {
      borderRadius: 4,
      background: '#CF3537',
      padding: '10px 16px',
      color: '#FFF',
      fontSize: 14,
      fontWeight: 400,
      marginLeft: 8
    }
  },
  okText,
  cancelText,
  cancelButtonProps = {
    style: {
      borderRadius: 4,
      background: '#FFF',
      color: '#14151C',
      fontSize: 14,
      fontWeight: 400,
      padding: '10px 16px',
      border: '1px solid #C2C7D0'
    }
  },
  onOk,
  afterClose,
  width = 520
}: ConfirmModalConfig) => {
  Modal.confirm({
    icon: null,
    className: 'cwf-confirm-modal',
    title: (
      <span className="flex items-center" style={{ gap: titleIconGap }}>
        <span className="flex items-center">{icon}</span>
        <span
          className="font-semibold text-lg text-neutral-1000"
          style={titleStyles}
        >
          {title}
        </span>
      </span>
    ),
    content: (
      <div className="flex items-start" style={contentStyles}>
        <span
          className="inline-block"
          style={{ width: contentGutterWidth, minWidth: contentGutterWidth }}
        />
        <span
          className="font-normal leading-normal wrap-break-word text-left mt-0 flex-1 text-neutral-1000"
          style={contentTextStyles}
        >
          {content}
        </span>
      </div>
    ),
    okText,
    cancelText,
    centered: true,
    closable: false,
    transitionName: '',
    maskTransitionName: '',
    width,
    okButtonProps,
    cancelButtonProps,
    onOk,
    afterClose,
    onCancel: () => {},
    maskClosable: false
  });
};

export default showConfirmModal;
